import Orders from '../Orders/Orders.js';
import Footer from '../Footer/Footer.js'

const OrdersWebPage = () => {

    return (
        <div>
            <Orders />
            <Footer />
        </div>
    );
}

export default OrdersWebPage;
